/**
 * tdesign v1.0.3
 * (c) 2023 tdesign
 * @license MIT
 */

import { useLayoutEffect } from 'react';
import { i as isFunction_1 } from '../_chunks/dep-f10515e8.js';
import '../_chunks/dep-c3f1141e.js';
import '../_chunks/dep-4941ebe7.js';
import '../_chunks/dep-e9b62d1f.js';
import '../_chunks/dep-88cd50bf.js';

function useResizeObserver(container, callback) {
  var containerObserver = null;
  var cleanupObserver = function cleanupObserver() {
    if (!containerObserver) return;
    containerObserver.unobserve(container);
    isFunction_1(containerObserver.disconnect) && containerObserver.disconnect();
    containerObserver = null;
  };
  var addObserver = function addObserver(el) {
    containerObserver = new ResizeObserver(callback);
    containerObserver.observe(el);
  };
  useLayoutEffect(function () {
    var isSupport = window && window.ResizeObserver;
    if (!isSupport) return;
    cleanupObserver();
    container && addObserver(container);
    return function () {
      cleanupObserver();
    };
  }, [container, containerObserver]);
}

export { useResizeObserver as default };
//# sourceMappingURL=useResizeObserver.js.map
